import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import Markdown from "./Markdown/Markdown";

export interface InvoiceDisputeReasonDialogProps {
  open: boolean;
  reason: string;
  onClose: () => void;
}

const InvoiceDisputeReasonDialog = ({ open, reason, onClose }: InvoiceDisputeReasonDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 2,
          m: 1,
          p: 0,
          maxWidth: "100vw",
        },
      }}
    >
      <DialogTitle sx={{ p: 2 }}>
        <Typography variant="h6" fontSize="18px">
          Dispute Reason
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ p: 2, pt: 1 }}>
        <Markdown content={reason} />
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0, justifyContent: "flex-end" }}>
        <Button size="medium" variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDisputeReasonDialog;
